import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CurrencyDollar, ChatCircle, Hammer, ShieldCheck } from '@phosphor-icons/react';
import { clientEscrowAPI } from '../../api/api';

export const HomeownerTodayStrip = ({ quotesWaiting = 0, unreadCount = 0, activeProjects = 0 }) => {
  const navigate = useNavigate();
  const [escrowsToFund, setEscrowsToFund] = useState(0);

  useEffect(() => {
    clientEscrowAPI.mine()
      .then(({ data }) => setEscrowsToFund((data?.escrows || []).filter((e) => e.status === 'pending').length))
      .catch(() => {});
  }, []);

  const scrollTo = (testid) => document.querySelector(`[data-testid="${testid}"]`)?.scrollIntoView({ behavior: 'smooth' });

  const cards = [
    { label: 'Quotes Waiting', value: quotesWaiting, icon: CurrencyDollar, color: '#059669', onClick: () => scrollTo('quotes-received-section'), testId: 'today-quotes-waiting' },
    { label: 'Escrows to Fund', value: escrowsToFund, icon: ShieldCheck, color: '#2563EB', onClick: () => scrollTo('client-escrows-section'), testId: 'today-escrows' },
    { label: 'Active Projects', value: activeProjects, icon: Hammer, color: '#EA580C', onClick: () => scrollTo('active-projects-section'), testId: 'today-projects' },
    { label: 'Unread Messages', value: unreadCount, icon: ChatCircle, color: '#7C3AED', onClick: () => navigate('/messages'), testId: 'today-messages' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-testid="homeowner-today-strip">
      {cards.map(({ label, value, icon: Icon, color, onClick, testId }) => (
        <button
          key={testId}
          onClick={onClick}
          className={`text-left bg-white dark:bg-neutral-800 border-2 rounded-xl p-3.5 shadow-[3px_3px_0px_#0F172A] dark:shadow-[3px_3px_0px_#2563EB] hover:-translate-y-0.5 active:translate-y-0 transition-all ${value > 0 ? 'border-[#0F172A] dark:border-neutral-600' : 'border-neutral-200 dark:border-neutral-700 opacity-70'}`}
          data-testid={testId}
        >
          <div className="flex items-center justify-between">
            <Icon size={20} weight="bold" style={{ color }} />
            <span className="text-2xl font-black text-neutral-900 dark:text-white">{value}</span>
          </div>
          <p className="text-[11px] font-bold uppercase tracking-wide text-neutral-500 dark:text-neutral-400 mt-1">{label}</p>
        </button>
      ))}
    </div>
  );
};

export default HomeownerTodayStrip;
